<template>
  <a-modal 
    v-model:visible="visible" 
    title="事件详情" 
    destroyOnClose 
    :footer="operationType === 2 ? null : undefined"
    :confirmLoading="loading"
    @ok="handleSave"
  >
    <a-spin :spinning="loading">
      <div class="container">
        <a-form
            :model="formData"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 14 }"
        >
          <a-form-item label="事件编号">
            <span>{{ formData.no }}</span>
          </a-form-item>

          <a-form-item label="事件类别">
            <span>{{ getCategoryLabel(formData.type) }}</span>
          </a-form-item>

          <a-form-item label="事件来源">
            <span>{{ getSourceLabel(formData.from) }}</span>
          </a-form-item>

          <a-form-item label="处理人">
            <a-select v-if="operationType === 1" v-model:value="formData.serviceProvider" @change="onChange" style="width:200px">
              <a-select-option v-for="serviceProvider of baseData.serviceProvider" :value="serviceProvider">{{
                  serviceProvider
                }}
              </a-select-option>
            </a-select>
            <span v-else>{{ formData.serviceProvider }}</span>
          </a-form-item>

          <a-form-item label="事件状态">
            <span>{{ getStatusLabel(formData.status) }}</span>
          </a-form-item>

          <a-form-item label="发布时间">
            <span>{{ formData.create_at }}</span>
          </a-form-item>

          <a-form-item label="位置">
            <span>{{ formData.location }}</span>
          </a-form-item>

          <a-form-item label="事件图片" v-if="formData.images">
            <div class="image-gallery">
              <div v-for="(image, index) in getImagesArray(formData.images)" :key="'event-img-'+index" class="image-item">
                <img :src="image" @click="showEnlargedImage(image)" class="clickable-image" />
              </div>
            </div>
          </a-form-item>

          <div v-if="formData.status === 91 || formData.process_memo || formData.process_images" style="width: 100%;height: 1px;background-color: rgba(0,0,0,0.2);margin-bottom: 20px;"></div>

          <!-- 只有处理过的事件才显示处理信息 -->
          <template v-if="formData.status === 91||formData.status === 20  || formData.process_memo || formData.process_images">
            <a-form-item label="处理方式">
              <span>已处理</span>
            </a-form-item>

            <a-form-item label="处理图片" v-if="formData.process_images">
              <div class="image-gallery">
                <div v-for="(image, index) in getImagesArray(formData.process_images)" :key="'process-img-'+index" class="image-item">
                  <img :src="image" @click="showEnlargedImage(image)" class="clickable-image" />
                </div>
              </div>
            </a-form-item>

            <a-form-item label="备注">
              <span>{{ formData.process_memo || '无备注' }}</span>
            </a-form-item>

            <a-form-item label="处理时间">
              <span>{{ formData.process_at }}</span>
            </a-form-item>
          </template>

          <!-- 审批模式下显示审批备注输入框 -->
          <template v-if="operationType === 2">
            <a-form-item label="审批备注">
              <a-textarea v-model:value="approvalMemo" rows="4" placeholder="请输入审批备注" />
            </a-form-item>
            
            <!-- 审批按钮 -->
            <div class="approval-actions">
              <a-button type="primary" @click="handleApproval(true)" :loading="submitting">通过</a-button>
              <a-button type="danger" @click="handleApproval(false)" :loading="submitting">不通过</a-button>
              <a-button @click="visible=false">取消</a-button>
            </div>
          </template>
        </a-form>
      </div>
    </a-spin>
  </a-modal>
  
  <!-- 图片放大查看弹窗 -->
  <a-modal
    v-model:visible="enlargedImageVisible"
    :footer="null"
    width="80%"
    title="查看图片"
    @cancel="enlargedImageVisible = false"
    :zIndex="1200"
    class="image-modal"
  >
    <div class="enlarged-image-container">
      <img :src="enlargedImageSrc" class="enlarged-image" />
    </div>
  </a-modal>
</template>

<script>
import randomData from "./data.js";
import { 
  EVENT_SOURCE_OPTIONS, 
  EVENT_CATEGORY_OPTIONS, 
  EVENT_STATUS_OPTIONS,
  EVENT_STATUS_LABEL,
  EVENT_SOURCE_LABEL,
  EVENT_CATEGORY_LABEL,
  EVENT_STATUS
} from "@/constants/eventEnums";
import api from "@/request/api";

export default {
  name: "EventDetail",
  data() {
    return {
      baseData: randomData,
      visible: false,
      readOnly: false,
      loading: false,
      submitting: false, // 审批提交状态
      operationType: 0, // 0-查看, 1-修改, 2-审批
      approvalMemo: "", // 审批备注
      originalHandler: "", // 保存原始处理人信息，用于检测是否有修改
      enlargedImageVisible: false, // 控制放大图片的显示
      enlargedImageSrc: "", // 放大显示的图片地址
      EVENT_STATUS_LABEL,
      EVENT_SOURCE_LABEL,
      EVENT_CATEGORY_LABEL,
      sourceOptions: EVENT_SOURCE_OPTIONS,
      categoryOptions: EVENT_CATEGORY_OPTIONS,
      statusOptions: EVENT_STATUS_OPTIONS,
      formData: {
        type: "",
        from: "",
        serviceProvider: "",
        status: "",
        create_at: "",
        location: "",
        no: "",
        images: "",
        process_memo: "",
        process_images: "",
        process_at: ""
      }
    }
  },
  mounted() {
    this.addEmmiter();
  },
  methods: {
    onChange() {
      console.log('表单数据变更:', this.formData);
    },
    getCategoryLabel(category) {
      return this.EVENT_CATEGORY_LABEL[category] || category;
    },
    getSourceLabel(source) {
      return this.EVENT_SOURCE_LABEL[source] || source;
    },
    getStatusLabel(status) {
      return this.EVENT_STATUS_LABEL[status] || status;
    },
    // 将逗号分隔的图片字符串转换为数组
    getImagesArray(imagesStr) {
      if (!imagesStr) return [];
      return imagesStr.split(',').filter(img => img.trim() !== '');
    },
    addEmmiter(){
      this.$emitter.on('open-event-detail', (type) => {
        if (type) {
          this.readOnly = false;
        } else {
          this.readOnly = true
        }
        this.visible = true;
      });
    },
    async fetchEventDetail(event_id) {
      if (!event_id) return;
      
      this.loading = true;
      try {
        const response = await api.events.detail( event_id );
        
        if (response) {
          const detail = response;
          this.formData = {
            type: detail.category,
            from: detail.source,
            serviceProvider: detail.handler,
            status: detail.status,
            create_at: detail.created_at ? new Date(detail.created_at).toLocaleString() : '',
            location: detail.location,
            no: detail.event_id,
            images: detail.images,
            process_memo: detail.process_memo,
            process_images: detail.process_images,
            process_at: detail.process_at ? new Date(detail.process_at).toLocaleString() : ''
          };
          
          this.originalHandler = detail.handler;
        }
      } catch (error) {
        console.error('获取事件详情失败:', error);
        this.$message.error('获取事件详情失败');
      } finally {
        this.loading = false;
      }
    },
    async handleSave() {
      if (this.operationType === 1 && this.formData.serviceProvider !== this.originalHandler) {
        this.submitting = true;
        try {
          await api.events.updateHandler(this.formData.no, this.formData.serviceProvider);
          this.$message.success('处理人修改成功');
          this.visible = false;
          this.$emit('refresh');
        } catch (error) {
          console.error('修改处理人失败:', error);
          this.$message.error('修改处理人失败');
        } finally {
          this.submitting = false;
        }
      } else {
        this.visible = false;
      }
    },
    async handleApproval(isApproved) {
      if (!this.formData.no) return;
      
      this.submitting = true;
      try {
        await api.events.update(this.formData.no, isApproved ? 91 : 92);
        
        this.$message.success(isApproved ? '审批通过成功' : '已拒绝审批');
        this.visible = false;
        
        this.$emit('refresh');
      } catch (error) {
        console.error('审批操作失败:', error);
        this.$message.error('审批操作失败');
      } finally {
        this.submitting = false;
      }
    },
    open(record, type) {
      this.approvalMemo = "";
      this.operationType = type;
      
      if (record && record.event_id) {
        this.fetchEventDetail(record.event_id);
      } else if (record) {
        this.formData = {
          type: record.category,
          from: record.source,
          serviceProvider: record.handler,
          status: record.status,
          create_at: record.created_at ? new Date(record.created_at).toLocaleString() : '',
          location: record.location,
          no: record.event_id,
          images: '',
          process_memo: '',
          process_images: '',
          process_at: record.process_at ? new Date(record.process_at).toLocaleString() : ''
        };
        
        this.originalHandler = record.handler;
      }
      
      if (type === 0) {
        this.readOnly = true;
      } else if (type === 1) {
        this.readOnly = false;
      } else if (type === 2) {
        this.readOnly = true;
      }
      
      this.visible = true;
    },
    
    // 显示放大的图片
    showEnlargedImage(src) {
      if (!src) return;
      this.enlargedImageSrc = src;
      this.enlargedImageVisible = true;
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height: calc(100vh - 300px);
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 1px; // 垂直滚动条宽度
  }
}

.approval-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 24px;
  margin-bottom: 16px;
}

.clickable-image {
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    opacity: 0.8;
  }
}

.enlarged-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.image-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.image-item {
  width: 120px;
  height: 90px;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    max-width: none;
    max-height: none;
  }
}

.enlarged-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}

/* 确保图片弹窗在最前面 */
:deep(.image-modal) {
  z-index: 1200 !important;
}
</style>